// extracted by mini-css-extract-plugin
export default {"footer":"designation-form-modal_footer__xIxnq","body":"designation-form-modal_body__bMzVg"};